import React from "react";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";
import { type DropdownProps } from "../models";
import CultureLabel from "components/Culture/CultureLabel";

const CultureDropdown = (props: DropdownProps<server.dto.Culture, server.dto.LCID>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={props.options}
    getLabel={culture => culture.text}
    getValue={culture => culture.lcid}
    value={props.value}
    onChange={props.onChange}
    config={{
      placeholder: RESX.Language.SelectLanguage,
      ...props.config
    }}
    renderOption={(culture) => <CultureLabel culture={culture} />}
    renderSelectedValue={(culture) => <CultureLabel culture={culture} />}
  />;
};

export default CultureDropdown;